var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFrame19(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 318,
    height: 182,
    viewBox: "0 0 318 182",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_47_272)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 137.557,
    y: -191,
    width: 21,
    height: 599,
    transform: "rotate(45 137.557 -191)",
    fill: "#FCF8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282.514,
    y: -46.0431,
    width: 20,
    height: 599,
    transform: "rotate(45 282.514 -46.0431)",
    fill: "#FCF8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.549,
    y: -162.009,
    width: 20,
    height: 599,
    transform: "rotate(45 166.549 -162.009)",
    fill: "#FCF8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.798,
    y: -17.7589,
    width: 21,
    height: 599,
    transform: "rotate(45 310.798 -17.7589)",
    fill: "#FCF8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.54,
    y: -133.017,
    width: 20,
    height: 599,
    transform: "rotate(45 195.54 -133.017)",
    fill: "#FCF8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.789,
    y: 11.2325,
    width: 21,
    height: 599,
    transform: "rotate(45 339.789 11.2325)",
    fill: "#FCF8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224.531,
    y: -104.026,
    width: 20,
    height: 599,
    transform: "rotate(45 224.531 -104.026)",
    fill: "#FCF8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 368.781,
    y: 40.2239,
    width: 21,
    height: 599,
    transform: "rotate(45 368.781 40.2239)",
    fill: "#FCF8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.522,
    y: -75.0345,
    width: 20,
    height: 599,
    transform: "rotate(45 253.522 -75.0345)",
    fill: "#FCF8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 397.772,
    y: 69.2153,
    width: 21,
    height: 599,
    transform: "rotate(45 397.772 69.2153)",
    fill: "#FCF8F8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_47_272"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 318,
    height: 184,
    rx: 10,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame19);
export default __webpack_public_path__ + "static/media/Frame 19.693a5aed885d95a54d0199458298655d.svg";
export { ForwardRef as ReactComponent };